import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { appRouter } from './app.router';

import { AppComponent } from './app.component';
import { NavbarComponent } from './components/view/navbar/navbar.component';
import { FooterComponent } from './components/view/footer/footer.component';
import { HttpClientModule } from '@angular/common/http';
import { SearchService } from './services/search.service';
import { SpinnerModule } from './modules/spinner/spinner.module';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar/dist/lib';
import { BsDropdownModule } from 'ngx-bootstrap';
import { ResponsiveService } from './services/responsive.service';
import { Angulartics2Module } from 'angulartics2';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { Angulartics2Facebook } from 'angulartics2/facebook';


@NgModule({
    declarations: [
        AppComponent,
        NavbarComponent,
        FooterComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        CommonModule,
        appRouter,
        SpinnerModule,
        ToasterModule,
        MalihuScrollbarModule.forRoot(),
        BsDropdownModule.forRoot(),
        Angulartics2Module.forRoot([Angulartics2GoogleAnalytics,Angulartics2Facebook]),
    ],
    providers: [
        SearchService,
        ToasterService,
        ResponsiveService,
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /Users/avihayev/Phone-Plans/Lading Page/landing-page-web/src/app/app.module.ts